var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('help.title')))]),_vm._v(" "),_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'styleguide' }}},[_vm._v("Styleguide")]),_vm._v(" "),_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'guidelines' }}},[_vm._v("Guidelines")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5027e7d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help.vue
// module id = 1112
// module chunks = 5